import { Theme, alpha, makeStyles } from "@material-ui/core"
import { MaterialSymbol } from "./MaterialSymbol"
import { HourReportingRoleType } from "../types"

type RoleCountPillProps = {
  roleType: HourReportingRoleType
  count: number
  label: string
  iconName: string
  onClick: () => void
}

export const RoleCountPill = ({ roleType, count, label, iconName, onClick }: RoleCountPillProps) => {
  const classes = useStyles()
  const pillClassName = roleType === "checker" ? classes.checkerCountPill : classes.approverCountPill

  return (
    <button className={classes.roleCountButton} type="button" onClick={onClick} aria-label={`${count} ${label}`}>
      <span className={`${classes.roleCountPill} ${pillClassName}`}>
        <MaterialSymbol name={iconName} className={classes.roleCountIcon} />
        <span>{count}</span>
      </span>
    </button>
  )
}

const useStyles = makeStyles((theme: Theme) => ({
  roleCountButton: {
    background: "transparent",
    border: 0,
    cursor: "pointer",
    padding: 0,
    "&:focus": {
      outline: 0,
    },
    "&:focus $roleCountPill": {
      boxShadow: `0 0 0 2px ${alpha(theme.palette.primary.main, 0.22)}`,
    },
    "&:hover $roleCountPill": {
      transform: "translateY(-1px)",
    },
    "&:active $roleCountPill": {
      transform: "translateY(0)",
    },
  },
  roleCountPill: {
    alignItems: "center",
    borderRadius: 6,
    borderStyle: "solid",
    borderWidth: 1,
    display: "inline-flex",
    fontSize: 12,
    fontWeight: 700,
    height: 24,
    lineHeight: 1,
    padding: theme.spacing(0, 0.75),
    transition: theme.transitions.create(["box-shadow", "transform", "background-color"], {
      duration: theme.transitions.duration.shortest,
    }),
  },
  checkerCountPill: {
    color: theme.palette.info.dark,
    borderColor: alpha(theme.palette.info.main, 0.35),
    backgroundColor: alpha(theme.palette.info.main, 0.1),
    "$roleCountButton:hover &": {
      backgroundColor: alpha(theme.palette.info.main, 0.16),
      boxShadow: `0 2px 6px ${alpha(theme.palette.info.main, 0.18)}`,
    },
  },
  approverCountPill: {
    color: theme.palette.success.dark,
    borderColor: alpha(theme.palette.success.main, 0.35),
    backgroundColor: alpha(theme.palette.success.main, 0.1),
    "$roleCountButton:hover &": {
      backgroundColor: alpha(theme.palette.success.main, 0.16),
      boxShadow: `0 2px 6px ${alpha(theme.palette.success.main, 0.18)}`,
    },
  },
  roleCountIcon: {
    color: "inherit",
    fontSize: 17,
    marginRight: theme.spacing(0.5),
    fontVariationSettings: "'FILL' 0, 'wght' 500, 'GRAD' 0, 'opsz' 18",
  },
}))
